<template>
  <div style="height: 82%; min-height: 500px;">
    <device-detail-dialog-header :device-info="deviceInfo" style="margin-bottom:40px;"></device-detail-dialog-header>
    <div style="height: 90%; overflow-y: auto; padding: 20px;">
      <el-row style="height: 100%; width: 100%;">
        <el-col :xl="14" :lg="14" :md="24" :sm="24" :xs="24">
          <div style="margin-right: 5px">
            <video-component :channel="selectChannel" :device-info="deviceInfo"
                             :properties="properties"></video-component>
          </div>
        </el-col>
        <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="24" style="height: 100%;" class="pointer">
          <div style="background-color: rgba(41, 155, 255, .1); height: 42%;margin-right: 5px;">
            <div style="padding: 30px 30px 20px 30px;" class="titleText">云台控制：</div>
            <el-col :span="12" style="margin: 5px auto;">
                <div style="width: 110px; height: 35px; text-align: center; margin: auto;" >
                  <div style="float: left; min-height:1px; height: 100%; width: 35px; margin-top: 2px;"></div>
                  <div style="float: left; background-color: #082f53; border-radius: 0px; height: 100%; width: 35px; text-align: center; margin-top: 2px; margin-left: 2px;"
                       @mousedown="videoMobility('TILT_UP',false)" @mouseup="videoMobility('TILT_UP',true)">
                    <a class="el-icon-caret-top" style="margin-top: 10px;"/>
                  </div>
                  <div style="float: left; min-height:1px; height: 100%; width: 35px; margin-top: 2px; margin-left: 1px;"></div>
                </div>
                <div style="width: 110px; height: 35px; text-align: center; margin: auto;">
                  <div style="float: left; background-color: #082f53; border-radius: 0px; height: 100%; width: 35px; text-align: center; margin-top: 2px;"
                       @mousedown="videoMobility('PAN_LEFT',false)" @mouseup="videoMobility('PAN_LEFT',true)">
                    <a class="el-icon-caret-left" style="margin-top: 10px;"/>
                  </div>
                  <div style="float: left; background-color: #082f53; border-radius: 0px; height: 100%; width: 35px; text-align: center; margin-top: 2px; margin-left: 2px;"
                       @mousedown="videoMobility('TILT_UP',false)" @mouseup="videoMobility('TILT_UP',true)">
                    <a class="el-icon-refresh" style="margin-top: 10px;"/>
                  </div>
                  <div style="float: left; background-color: #082f53; border-radius: 0px; height: 100%; width: 35px; text-align: center; margin-top: 2px; margin-left: 2px;"
                       @mousedown="videoMobility('PAN_RIGHT',false)" @mouseup="videoMobility('PAN_RIGHT',true)">
                    <a class="el-icon-caret-right" style="margin-top: 10px;"/>
                  </div>
                </div>
                <div style="margin-top: 2px; width: 107px; height: 35px; text-align: center; margin: auto;">
                  <div style="float: left; min-height:1px; height: 100%; width: 35px; margin-top: 2px;"> </div>
                  <div style="float: left; background-color: #082f53; border-radius: 0px; height: 100%; width: 35px; text-align: center; margin-top: 2px; margin-left: 1px;"
                       @mousedown="videoMobility('TILT_DOWN',false)" @mouseup="videoMobility('TILT_DOWN',true)">
                    <a class="el-icon-caret-bottom" style="margin-top: 10px;"/>
                  </div>
                  <div style="float: left; min-height:1px; height: 100%; width: 35px; margin-top: 2px; margin-left: 1px;"></div>
                </div>
            </el-col>
            <el-col :span="12" class="detailText">
              <div style="width: 80%;">
                <el-col :span="11">
                  <div class="operationButton"
                    @mousedown="videoMobility('ZOOM_IN',false)" @mouseup="videoMobility('ZOOM_IN',true)">
                    <a>变倍+</a>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="operationButton" style="margin-left: 1px;"
                    @mousedown="videoMobility('ZOOM_OUT',false)" @mouseup="videoMobility('ZOOM_OUT',true)">
                    <a>变倍-</a>
                  </div>
                </el-col>
              </div>
              <div style="width: 80%;">
                <el-col :span="11">
                  <div class="operationButton"
                       @mousedown="videoMobility('FOCUS_NEAR',false)" @mouseup="videoMobility('FOCUS_NEAR',true)">
                    <a>变焦+</a>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="operationButton" style="margin-left: 1px;"
                    @mousedown="videoMobility('FOCUS_FAR',false)" @mouseup="videoMobility('FOCUS_FAR',true)">
                    <a>变焦-</a>
                  </div>
                </el-col>
              </div>
              <div style=" width: 80%;">
                <el-col :span="11">
                  <div class="operationButton"
                       @mousedown="videoMobility('IRIS_OPEN',false)" @mouseup="videoMobility('IRIS_OPEN',true)">
                    <a >光圈+</a>
                  </div>
                </el-col>
                <el-col :span="11">
                  <div class="operationButton" style="margin-left: 1px;"
                    @mousedown="videoMobility('IRIS_CLOSE',false)" @mouseup="videoMobility('IRIS_CLOSE',true)">
                    <a >光圈-</a>
                  </div>
                </el-col>
              </div>
            </el-col>
          </div>
          <div class="videoTime" style="background-color: rgba(41, 155, 255, .1); height: 56%; margin-top: 5px; margin-right: 5px; ">
            <div style="padding: 30px 30px 20px 30px;" class="titleText"> 回放时间：</div>
            <div style="margin: auto; width: 60%;">
              <div class="block detailText">
                开始时间:
                <el-date-picker
                  size="mini"
                  v-model="startTime"
                  type="datetime"
                  placeholder="选择开始日期时间"
                  style="width: 99%"
                  default-time="12:00:00">
                </el-date-picker>
              </div>
            </div>
            <div style="margin: 10px auto; width: 60%;">
              <div class="block detailText">
                结束时间:
                <el-date-picker
                  size="mini"
                  v-model="endTime"
                  type="datetime"
                  placeholder="选择结束日期时间"
                  style="width: 99%"
                  default-time="12:00:00">
                </el-date-picker>
              </div>
            </div>
            <div style="margin-top: 30px; text-align: center">
              <el-button @touchstart="commitSystematic" @click="commitSystematic"  size="mini" type="primary">确 定</el-button>
            </div>
          </div>
        </el-col>
        <el-col :xl="5" :lg="5" :md="12" :sm="12" :xs="24" style="height: 100%;">
          <div style="background-color: rgba(41, 155, 255, .1); height: 99%; width: 100%; margin-right: 5px;">
            <div style="padding: 30px 30px 20px 30px;" class="titleText">预设位：</div>
            <div style="height: 80%; overflow: auto; margin: auto; margin-left: 20px; width: 85%;" class="selectPoint detailText">
              <div style="cursor:pointer; height: 35px; text-align: center;" v-for="presetPointSize in presetPointSum" :key="presetPointSize" @touchstart="selectPresetPoint(presetPointSize)" @click="selectPresetPoint(presetPointSize)">
                <el-col :span="14" style="margin: 5px auto; text-align: center;" :class="presetPointSize==selectPoint?'selectPointText':''">
                  预设位置{{presetPointSize}}
                </el-col>
                <el-col :span="10" style="margin-top: 5px;" v-if="presetPointSize==selectPoint">
                  <img src="../../assets/images/comprehensive/video_back.png"
                     @touchstart="presetPointVideo()"  @click="presetPointVideo()">
                  <img style="margin-left: 10px;" src="../../assets/images/comprehensive/video_setting.png"
                     @touchstart="setPresetPoint()"  @click="setPresetPoint()">
                </el-col>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import VideoComponent from "@/components/video/VideoComponent";
import DeviceDetailDialogHeader from "@/components/device_details/comp/DeviceDetailHeader";
import {ptzControl, ptzPreset} from "@/network/DVR";

export default {
  name: "VideoFullScreen",
  components: {DeviceDetailDialogHeader, VideoComponent},
  props: ["selectChannel", "deviceInfo", "properties"],
  data() {
    return {
      startTime: '',
      endTime: '',
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      brandEnum: 'hikvision',
      presetPointSum:30,// 预置点总数
      selectPoint: 0,
    }
  },

  methods: {
    // 预置点视角
    presetPointVideo(){
      console.log("预置点视角查看"+this.selectPoint);
      this.controlPtzPreset('GOTO_PRESET',this.selectPoint);
    },
    // 设置预置点
    setPresetPoint(){
      console.log("设置预置点"+this.selectPoint);
      this.controlPtzPreset('SET_PRESET',this.selectPoint);
    },
    // 选中预置点
    selectPresetPoint(selectPoint){
      this.selectPoint=selectPoint;
    },
    // 回放
    commitSystematic(){
      if(!this.$stringIsNotNullAndEmpty(this.startTime) && !this.$stringIsNotNullAndEmpty(this.endTime)){
        this.$message({
          message: '请先选择回放时间',
          type: 'warning'
        });
        return;
      }
      this.$message({
        message: '未找到回放文件',
        type: 'warning'
      });
    },
    //视频移动
    videoMobility(ptzCommandEnum, stop) {
      ptzControl(this.brandEnum, 1, this.properties.IP, this.properties.pwd, this.properties.PORT, ptzCommandEnum, stop, this.properties.User).then(res => {
        if (res.code == 0) {
          // this.$message.info('视频移动');
        }
      });
    },
    //云台控制-预置点控制
    controlPtzPreset(ptzCommandEnum, dwPresetIndex) {
      console.log(dwPresetIndex);
      ptzPreset(this.brandEnum, 1, this.properties.IP, this.properties.pwd, this.properties.PORT, ptzCommandEnum, dwPresetIndex, this.properties.User).then(res => {
        if (res.code == 0) {
          // this.$message.info('视频移动');
        }
      });
    },
  }
}
</script>

<style scoped>
.operationButton {
  background-color: #082f53;
  width: 100%;
  height: 35px;
  order-radius: 2px;
  text-align: center;
  line-height: 35px;
  margin-top: 5px;
}

.selectPoint{
  border: 1px solid rgba(41, 155, 255, .3);
}
.selectPointText{
  color: #299BFF;
}
.titleText {
  font-size: 1rem;
}
.detailText {
  font-size: 0.8rem;
}
</style>
